import React, { FC } from 'react';
import { StyledLine } from '../ContactInformation.styles';

export interface ContentProps {
  lines: (JSX.Element | string)[];
}

const Content: FC<ContentProps> = ({ lines }) => (
  lines ? (
    <>
      {lines.map((line, index) =>
        line ? <StyledLine key={index}>{line}</StyledLine> : null)}
    </>
  ) : null
);

export default Content;
